/** Created by azhou on 2019/2/18.*/
<template>
  <div class="arr-wrap">
    <div class="upload-btn" v-show="showUploadIcon">
      <input type="file" ref="referenceUpload" :multiple="multiMode" accept="image/*,.pdf" @change="onRead"/>
      <i class="iconfont icon-xiangji"></i>
    </div>    
    <!--图片数组-->
    <div class="file-arr" v-for="(imgItem,index) in showArr" :key="index">
      <div class="file-name">
        <a href="javascript:;" @click="handleLoad(imgItem)">文件{{index+1}}</a>
      </div>
      <div class="img-mask rounded" v-show="editMode">
        <!-- <i class="el-icon-zoom-in cursor-pointer" @click="imgPreview(index)"></i> -->
        <i class="el-icon-delete cursor-pointer" @click="deleteImg(index)"></i>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      existImgs: {},                                   //已存在的图片，为单文件时自动推入数组
      maxLength: {                                     //最大可上传的图片数
        type: Number,
        default: 20
      },
      editMode: {                                     //是否为编辑模式
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        fileArr: [],
        imgArr: [],                                 //用来保存缩略图的图片展示，主要为base64格式和cdn图片地址格式
      }
    },
    watch: {
      existImgs (newVal) {
        if (newVal) this.initImgArr();
        else this.imgArr = [];
      }
    },
    created() {
      if (this.existImgs) this.initImgArr();
    },
    computed: {
      //是否显示上传按钮
      showUploadIcon () {
        //编辑模式下图片小于最多可上传时显示上传按钮
        if (this.editMode) return this.imgArr.length < this.maxLength
        else return false
      },
      //是否为多选模式，当最大图片长度大于1时为多选
      multiMode () {
        return this.maxLength > 1;
      },
      //单选或多选模式下渲染的数组
      showArr() {
        return this.multiMode ? this.imgArr : this.imgArr.slice(0,1)
      }
    },
    methods: {
      /*初始化传入的图片数组到显示图片数组*/
      initImgArr() {
        let str = ';base64,',exists = this.existImgs;
        if (!$.isArray(exists) && exists) {               //不是数组时作为数组元素推入数组
          let item = exists.indexOf(str) !== -1 ? exists : (this.ImgPreUrl + exists);
          this.imgArr.push(item);
        } else if ($.isArray(exists)) {                   //多张图片数组时拼接到imgArr中
          this.imgArr = this.existImgs.concat([])
        }
      },
      /*加载本地图片文件*/
      fileReaderPromise(file) {
        return new Promise((resolve, reject) => {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = (e) => resolve(e.target.result);
        });
      },
      async onRead (e) {
        let files = e.target.files;
        //将文件对象转为数组格式
        this.fileArr = []
        for (let i = 0; i < files.length; i++) {
          this.fileArr.push(files[i])
        }
        //将所有文件转base64事件推入队列
        let filesPromise = this.fileArr.map(file => this.fileReaderPromise(file));
        let resultArr = await Promise.all(filesPromise);
        let totalArr = this.imgArr.concat(resultArr);
        if (totalArr.length > this.maxLength) {
          this._alert('照片最多只能上传' + this.maxLength + '张哦',null,'error');
          this.imgArr = totalArr.slice(0, this.maxLength);
        } else this.imgArr = totalArr;
        this.$emit('fileChange', this.imgArr)
        this.$refs.referenceUpload.value = null
      },
      /*图片预览*/
      imgPreview (index) {
        this._CarouselView({
          currentImg: index,
          picArray: this.imgArr
        })
      },
      /*本地删除某张图片*/
      deleteImg (index) {
        this.imgArr.splice(index, 1)
        this.$emit('fileChange', this.imgArr)
      },

      handleLoad(base64Str){
        if(base64Str.indexOf(';base64,')<0){
          window.open(this.$GFUN.formatImgSrc(base64Str));
          return
        }
        // 将base64字符串转换为Blob对象
        const blob = b64toBlob(base64Str);
        // 生成Blob对象的URL，并在当前窗口中打开
        window.open(URL.createObjectURL(blob));

        function b64toBlob(base64) {
          const parts = base64.split(',');
          const contentType = parts[0].split(';')[0].split(':')[1];
          const byteCharacters = atob(parts[1]);
          const byteArrays = [];

          for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
            const slice = byteCharacters.slice(offset, offset + 1024);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
          }

          return new Blob(byteArrays, {type: contentType});
        }

      }
    }
  }
</script>
<style lang="scss" scoped>
  .arr-wrap {
 
    align-items: center;
    flex-wrap: wrap;
  }



  .file-arr {
    width: 80px;
    // height: 80px;
    position: relative;
    margin: 0 5px 10px 0;

    display: flex;
    align-items: center;    

    .file-name{
      margin-right: 10px;
    }
 
  }

  .upload-btn {
    width: 80px;
    height: 80px;
    margin: 0 5px 10px 0;
    border: 1px dotted dodgerblue;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.2rem;
    position: relative;
    cursor: pointer;
    .icon-xiangji{
      font-size: 30px;
      color: #41baff;
    }
    input {
      cursor: pointer;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
</style>
